import { render } from "./HistoryScores.vue?vue&type=template&id=68046ad7&scoped=true&ts=true"
import script from "./HistoryScores.vue?vue&type=script&lang=ts"
export * from "./HistoryScores.vue?vue&type=script&lang=ts"

import "./HistoryScores.vue?vue&type=style&index=0&id=68046ad7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68046ad7"]])

export default __exports__